interface ServicesProps {
  onBookingClick: () => void;
}

export default function Services({ onBookingClick }: ServicesProps) {
  const services = [
    {
      icon: 'ri-search-line',
      title: 'Wo liegt dein größter Hebel?',
      description: 'Wir schauen hin, wo Zeit und Geld verloren gehen. Chancen, Risiken, priorisierte Use Cases – und ein realistischer Blick auf deinen ROI.'
    },
    {
      icon: 'ri-database-2-line',
      title: 'Von deinen Daten zum Prototypen',
      description: 'Wir klären, welche Daten es gibt, wie verlässlich sie sind und wofür sie sich eignen. Darauf bauen sinnvolle Automatisierungen und KI‑Lösungen – plus ein schneller Prototyp, mit dem ihr sie im Alltag erstmals testen könnt.'
    },
    {
      icon: 'ri-team-line',
      title: 'KI als Teammitglieder integrieren',
      description: 'Statt Tools definieren wir konkrete KI‑Assistent:innen für dein Business. Wir klären Rollen, Regeln und Abläufe, damit KI in deine Organisation und Kultur passt – inklusive Schulungen, Playbooks und Quality Gates.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Von Konzept zu messbaren Ergebnissen',
      description: 'Rollen werden zu verlässlichen Workflows, die im Alltag tragen. Wir begleiten die Umsetzung, damit KI spürbar Zeit spart, Qualität hebt und Wachstum unterstützt – und bleiben als Sparringpartner an deiner Seite.'
    }
  ];

  return (
    <section id="prozess" className="py-20 lg:py-32 px-6 lg:px-12 bg-[#D7D7D7]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm text-[#0A6AF0] font-normal mb-2 uppercase tracking-wide">
            Prozess
          </p>
          <h2 className="text-3xl lg:text-5xl text-[#042A60] mb-4 font-light">
            Wie wir KI zu deinem Wettbewerbsvorteil machen
          </h2>
          <p className="text-base text-[#042A60]/70">
            Vier Schritte von der Idee zur Realität
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {services.map((service, index) => (
            <div key={index} className="p-6 hover:shadow-md transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl text-[#042A60]`}></i>
              </div>
              <h3 className="text-lg font-medium text-[#042A60] mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-[#042A60]/70 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            
          <button 
              onClick={onBookingClick}
              className="px-6 py-2.5 bg-[#042A60] text-white text-sm font-normal border border-[#042A60] hover:bg-[#0A6AF0] hover:border-[#0A6AF0] transition-colors cursor-pointer whitespace-nowrap"
            >
              Termin vereinbaren
            </button>
            <a 
              href="#contact"
              className="px-6 py-2.5 text-[#042A60] text-sm font-normal hover:text-[#0A6AF0] transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center"
            >
              Mehr
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
